import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
 
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/index',
  //   children: [{
  //     path: 'index',
  //     name: 'index',
  //     component: () => import('@/views/index/index'),
  //     meta: {title: '首页Demo', icon: 'home'}
  //   }
  //   ]
  // },
  {
    path: "/",
    component: Layout,
    hidden: true,
    redirect: "noredirect",
    children: [
      {
        path: "/updatePassWord",
        name: "updatePassWord",
        component: () => import("@/views/login/updatePassWord"),
        meta: { title: "修改密码", icon: "" }
      }
    ]
  }


];

export const asyncRouterMap = [
  {
    path: "/ums-home",
    component: Layout,
    redirect: "/ums-home",
    name:'ums-home',
    meta: { title: "首页", icon: "ums-home" },
    children: [
      {
        path: "",
        name: "",
        component: () => import("@/views/index/index"),
        meta: { title: "首页", icon: "ums-home",isAuth: true  }
      }
    ]
  },
  {
    path: "/ums-data",
    component: Layout,
    redirect: "",
    name:'ums-data',
    meta: { title: "数据管理", icon: "ums",isAuth: true  },
    children: [
      {
        path: "",
        name: "",
        component: () => import("@/views/umsdata/index"),
        meta: { title: "数据管理", icon: "ums-admin",isAuth: true  }
      },
      {
        path: "addModel",
        name: "addModel",
        component: () => import("@/views/umsdata/addModel"),
        meta: {title: '新增', icon: 'ums-admin'},
        hidden: true
      }
    ],
    beforeEach:(to) =>{
      //console.log(to,'---to')
    }
  },
  {
    path: "/dictionarManagement",
    component: Layout,
    redirect: "/dictionarManagement/range",
    name: "dictionarManagement",
    meta: { title: "字典管理", icon: "ums" },
    children: [
      {
        path: "range",
        name: "range",
        component: () => import("@/views/dictionarManagement/range/index"),
        meta: { title: "值域字典", icon: "ums-admin" }
      },
      {
        path: "medicine",
        name: "medicine",
        component: () => import("@/views/dictionarManagement/medicine/index"),
        meta: { title: "药物字典", icon: "ums-admin" }
      }
    ]
  },
 
  
  {
    path: "/daily-record",
    component: Layout,
    redirect: "",
    name:'ums-log',
    meta: { title: "日志管理", icon: "ums" },
    children: [
      {
        path: "",
        name: "",
        component: () => import("@/views/dailyRecord/index"),
        meta: { title: "日志管理", icon: "order" }
      }
    ]
  },
  // 用户反馈
  {
    path:'/user-feedback',
    component: Layout,
    name:'ums-feedback',
    meta: {title: '用户反馈', icon: 'ums'},
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/userFeedback/index'),
        meta: {title: '用户反馈', icon: 'ums-feedback'}
      },
    ]
  },

  {
    path: "/ums-version",
    component: Layout,
    name:'ums-version',
    meta: { title: "版本管理", icon: "ums" },
   
    children: [
      {
        path: "",
        name: "",
        component: () => import("@/views/ums/version/index"),
        meta: { title: "版本管理", icon: "ums-version" }
      }
    ]
  },
  {
    path: "/documentCenter",
    component: Layout,
    name:'ums-doc',
    meta: { title: "文档中心", icon: "ums" },
    redirect: "",
    children: [
      {
        path: "",
        name: "",
        component: () => import("@/views/documentCenter/index"),
        meta: { title: "文档中心", icon: "ums-doc" }
      },
      {
        path: "add",
        name:'add',
        component: () => import("@/views/documentCenter/documentQuill"),
        meta: { title: "新增", icon: "ums-doc1" },
        hidden: true
      }
    ]
  },
  {
    path: "/helpCenter",
    component: Layout,
    name:'',
    meta: { title: "帮助中心", icon: "ums" },
    redirect: "",
    hidden:true,
    children: [
      {
        path: "",
        name: "helpCenter",
        component: () => import("@/views/helpCenter/index"),
        meta: { title: "帮助中心", icon: "" },
        hidden:true
      }
    ]
  },
  {
    path: "/admin",
    component: Layout,
    // redirect: '/role/admin',
    name: 'admin',
    meta: { title: "用户管理", icon: "ums" },
    redirect: "",
    children: [
      {
        path: "",
        name: "",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "用户管理", icon: "ums-admin" }
      }
    ]
  },
  {
    path: "/role",
    component: Layout,
    name:'role',
    meta: { title: "权限管理", icon: "ums" },
    // redirect: "/role/index",
    children: [
      {
        path: "",
        name: "",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "权限管理", icon: "ums" }
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: { title: "新建" },
        hidden: true
      }
    ]
  },
  
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js